import { useState } from 'react';
import NumberOfAbsencesEditing from '../NumberOfAbsencesEditing';
import NumberOfAbsencesStatic from '../NumberOfAbsencesStatic';
import { IUserAbsences } from '../../../hooks/promises/getUserAbsences';
import Spinner from '../../../components/Spinner/Spinner';

interface INumberOfAbsencesInputProps {
  userAbsences: IUserAbsences | null;
  addUserAbsences: (daysOfAbsence: number) => Promise<void>;
  refetch: () => void;
  thisMonthYear: string;
}

function NumberOfAbsencesInput({
  addUserAbsences,
  userAbsences,
  refetch,
  thisMonthYear,
}: INumberOfAbsencesInputProps) {
  const [editing, setEditing] = useState(false);
  const [saving, setSaving] = useState(false);

  if (saving)
    return (
      <div className="flex justify-center">
        <Spinner />
      </div>
    );

  return editing ? (
    <NumberOfAbsencesEditing
      userAbsences={userAbsences}
      setEditing={setEditing}
      addUserAbsences={addUserAbsences}
      setSaving={setSaving}
      refetch={refetch}
      thisMonthYear={thisMonthYear}
    />
  ) : (
    <NumberOfAbsencesStatic
      userAbsences={userAbsences}
      setEditing={setEditing}
      thisMonthYear={thisMonthYear}
    />
  );
}

export default NumberOfAbsencesInput;
